import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.ProfileEditPopup.SectionSecurity.SubsectionEmail', {
    title: 'Email',
    descriptionForUser: 'You can change your email address up to 5 (five) times.',
    descriptionForAdmin: 'To change your email address, please contact our Customer Support team.',
    descriptionForAdminRequested: `We've sent a request to Customer Support to confirm the change of your email address to {newEmail}`,
    buttonChange: 'Change',
    buttonContactSupport: 'Contact support',
    buttonCancel: 'Cancel email change',
});
